export default __webpack_public_path__ + "static/media/requests.de2cea32.svg";